<template>
  <div class="wrapper">
    <!-- タイトル -->
    <div v-bind:class="title_class" class="title_container">
      <div class="title_l">
        <img src="../assets/img/top/title_l.png" />
        <img class="exp" src="../assets/img/top/title_exp.png" />
      </div>
      <div class="title_r">
        <img src="../assets/img/top/title_r.png" />
        <img class="ima" src="../assets/img/top/title_ima.png" />
      </div>
    </div>

    <!-- 地球 -->
    <div v-bind:class="earth_class" class="earth">
      <img src="../assets/img/common/earth.png" />
      <div class="calc_messsage">{{ calc_message }}</div>
    </div>

    <!-- 時計の中身 -->
    <div v-bind:class="content_class" class="content_container">
      <!-- 選択できる時間 -->
      <div class="input_time_container">
        <div>
          <span class="date">
            <input type="date" v-model="input_date" v-on:click="stopTimer" />
            {{ display_date }}
          </span>
          <span class="time">
            <input type="time" v-model="input_time" v-on:click="stopTimer" />
            {{ display_time }}
          </span>
          <span class="dela_font">に</span>
        </div>
      </div>

      <!-- 地球が何回回ったか表示する部分 -->
      <div class="rotate_num_container">
        <div class="top_num">
          <span class="dela_font val">{{ top_rotate_num }}</span>

          <span class="chikyuu_text dela_font">地球が...</span>
          <div class="chou_text">
            <span class="chou_text tanni dela_font red">兆</span>
            <span class="chou_text tanni dela_font blue">兆</span>
          </div>
          <div class="oku_text">
            <span class="tanni dela_font red">億</span>
            <span class="tanni dela_font blue">億</span>
          </div>
          <div class="man_text">
            <span class="tanni dela_font red">万</span>
            <span class="tanni dela_font blue">万</span>
          </div>
        </div>
        <div class="bottom_num">
          <span class="dela_font val">{{ bottom_rotate_num }}</span>

          <div class="kai_text">
            <span class="tanni dela_font red">回</span>
            <span class="tanni dela_font blue">回</span>
          </div>
        </div>
        <div class="bottom_text">
          <div class="mawaru_container">
            <span class="dela_font mawaru red">まわったか</span>
            <span class="dela_font mawaru orange">まわったか</span>
          </div>
          <div class="exp_text dela_font">
            <span class="dela_font exp red">!?</span>
            <span class="dela_font exp white">!?</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer_container">
      <a  href="https://gakuen.moteamasu.jp/">
        <img src="../assets/img/common/logo.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      calc_message: "",
      title_class: "display",
      content_class: "none",
      earth_class: "init",
      input_date: "2020-01-01",
      input_time: "12:00",
      display_date: "2020年1月1日",
      display_time: "12:00:00",
      top_rotate_num: "",
      bottom_rotate_num: "",
      is_change_time: false,
      // 開発用 or 本番用
      env: "prod",
    };
  },
  mounted() {
    // 本番用 ここから
    if (this.env == "prod") {
      let loop_num = 0;
      // 3秒後に地球が移動（移動に1秒かかる）
      setTimeout(() => {
        this.title_class = "none";
        this.earth_class = "calc";
      }, 3000);
      // 4秒後（地球が移動後）にタイマースタート
      setTimeout(() => {
        const interval_id = setInterval(() => {
          if (this.calc_message == "計算中") {
            this.calc_message = "計算中.";
          } else if (this.calc_message == "計算中.") {
            this.calc_message = "計算中..";
          } else if (this.calc_message == "計算中..") {
            this.calc_message = "計算中...";
          } else {
            this.calc_message = "計算中";
          }
          loop_num++;
          if (loop_num == 100) {
            clearInterval(interval_id);
          }
        }, 300);
      }, 4000);
      // 7秒後に地球が移動
      setTimeout(() => {
        this.earth_class = "time";
        this.content_class = "display";
      }, 7000);
    }
    // 本番用 ここまで

    // テスト用 ここから
    if (this.env == "local") {
      this.title_class = "none";
      this.earth_class = "time";
      this.content_class = "display";
    }
    // テスト用 ここまで

    // 1秒おきに今の時間を設定 ＋ 表示されている回転数の値を更新    
    setInterval(() => {
      // 時間を変更していない場合は毎秒今の時間に合わせる
      if (!this.is_change_time) {
        const now = new Date();
        this.setInputDateTime(now);

        // 時間変更後は仕方ないので1秒ずつ＋していく
      } else {
        console.log(`${this.input_date.replace(/-/g, "/")} ${this.input_time}`);
        const set_date = new Date(`${this.input_date.replace(/-/g, "/")} ${this.input_time}`);
        set_date.setSeconds(set_date.getSeconds() + 1);
        this.setInputDateTime(set_date);
      }

      // 回転数の更新
      this.updateEarthRotateNum();
    }, 1000);
  },

  watch: {
    input_date: {
      handler: function (new_input_date) {
        const split_date = new_input_date.split("-");
        const year = Number(split_date[0]);
        const month = Number(split_date[1]);
        const day = Number(split_date[2]);

        this.display_date = `${year}年${month}月${day}日`;
        this.updateEarthRotateNum();
      },
    },

    input_time: {
      handler: function (new_input_time) {
        if (new_input_time.split(":").length == 2) {
          this.display_time = `${new_input_time}:00`;
        } else {
          this.display_time = new_input_time;
        }
        this.updateEarthRotateNum();
      },
    },
  },

  methods: {
    // 地球が何回回ったか計算して設定する
    // 2000年の段階でちょうど地球が46億年たったと仮定
    // 1年で地球が365.2422回回ると仮定
    updateEarthRotateNum() {
      const now = new Date(this.input_date.replace(/-/g, "/"));
      const zero_year = new Date("2000/01/01 00:00:00");
      let diff_days = (now - zero_year) / 86400000;

      const earth_rotate_num = 1008069200001 + Math.ceil((365.2422 / 365) * diff_days);
      const earth_rotate_num_text = String(earth_rotate_num.toLocaleString());      
      this.top_rotate_num = earth_rotate_num_text.substring(0, 12);
      this.bottom_rotate_num = earth_rotate_num_text.substring(12);
    },

    setInputDateTime(datetime) {
      const year = datetime.getFullYear();
      const month = datetime.getMonth() + 1;
      const day = datetime.getDate();
      const hour = datetime.getHours();
      const minute = datetime.getMinutes();
      const second = datetime.getSeconds();      

      this.input_date = `${year}-${this.zfill(month)}-${this.zfill(day)}`;
      this.input_time = `${this.zfill(hour)}:${this.zfill(minute)}:${this.zfill(second)}`;
    },

    stopTimer() {
      this.is_change_time = true;
    },

    zfill(num){
      return ( '00' + num ).slice( -2 );
    }
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  margin: 0 auto;
  padding: 5rem 0 0;
  width: 100%;
  height: 100%;
  max-width: 1100px;
}
.title_container {
  margin: 2rem auto;
  width: 100%;
  max-width: 768px;
  display: flex;
  align-items: flex-start;
}
.title_container.none {
  display: none;
}
.title_l,
.title_r {
  position: relative;
  width: 88px;
  padding: 0 1rem;
  background-color: #a67c52;
}

.title_l img,
.title_r img {
  position: relative;
  right: 4px;
}
.title_r {
  margin-left: 1.5rem;
}

.title_r img.ima {
  position: absolute;
  width: 32px;
  top: -9px;
  right: -19px;
}

.title_l img.exp {
  position: absolute;
  width: 57px;
  bottom: -14px;
  right: -15px;
  transform: rotate(-5deg);
}

.earth img {
  width: 100%;
  height: 100%;
  animation: rotate_loop 100s linear infinite;
}

@keyframes rotate_loop {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.earth {
  position: fixed;
  transition: all 1s ease;
}
.earth.init {
  width: 500px;
  height: 500px;
  top: 300px;
  left: calc(50% + 10px);
}

.earth.calc {
  width: 200px;
  height: 200px;
  top: calc(50vh - 100px);
  left: calc(50vw - 100px);
}

.calc_messsage {
  display: none;
  color: #fff;
  padding-left: 78px;
  margin-top: 1.5rem;
  font-size: 0.875rem;
}

.earth.calc .calc_messsage {
  display: block;
}

.earth.time {
  width: 130vw;
  height: 130vw;
  left: -15vw;
  bottom: -95vw;
}

.content_container {
  display: none;
  width: 600px;
  margin: 0 auto;
  text-align: center;
}
.content_container.display {
  display: block;
}

.input_time_container span {
  color: #fff;
  font-size: 1.5rem;
}

.input_time_container span.date,
.input_time_container span.time {
  background-color: rgba(255, 255, 255, 0.16);
  display: inline-block;
  position: relative;
  padding: 0.75rem 2rem 0.75rem 3.5rem;
  border-radius: 4px;
  margin-right: 1rem;
  font-weight: bold;
}

.input_time_container span.date {
  letter-spacing: 2px;
}

.input_time_container span.date:before {
  position: absolute;
  top: 17px;
  left: 26px;
  content: "";
  width: 16px;
  height: 16px;
  background-image: url("../assets/img/common/calendar.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

.input_time_container span.time {
  letter-spacing: 3px;
}

.input_time_container span.time:before {
  position: absolute;
  top: 17px;
  left: 24px;
  content: "";
  width: 16px;
  height: 16px;
  background-image: url("../assets/img/common/tokei.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

input[type="date"],
input[type="date"]::-webkit-calendar-picker-indicator,
input[type="time"],
input[type="time"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 0;
  margin: 0;
  padding: 0;
}

input[type="date"]::-webkit-calendar-picker-indicator:hover,
input[type="time"]::-webkit-calendar-picker-indicator:hover {
  cursor: pointer;
}

.rotate_num_container {
  margin-top: 6rem;
}

.top_num .val,
.bottom_num .val {
  -webkit-text-stroke: 2px #ff1219;
  text-stroke: 2px #ff1219;
  color: #fff;
  text-shadow: 4px 4px #ff1219;
}

.top_num {
  font-size: 3rem;
  position: relative;
  width: min-content;
  margin: 0 auto 0.5rem;
}

.bottom_num {
  font-size: 4rem;
  position: relative;
  position: relative;
  width: min-content;
  margin: 0 auto 1.125rem;
}
.chikyuu_text {
  position: absolute;
  color: #fff;
  background-color: #222222;
  transform: rotate(-15deg);
  padding: 0.5rem 0.75rem;
  font-size: 1.75rem;
  top: -53px;
  left: -3rem;
}

.chou_text {
  position: absolute;
  bottom: 19px;
  left: 23px;
}

.oku_text {
  position: absolute;
  bottom: 19px;
  left: 210px;
}

.man_text {
  position: absolute;
  bottom: 19px;
  right: -5px;
}

.kai_text {
  position: absolute;
  bottom: 33px;
  right: -7px;
}

.tanni {
  font-size: 1.75rem;
  position: absolute;
}

.kai_text .tanni {
  font-size: 1.875rem;
}

.tanni.blue {
  color: #0261a7;
  -webkit-text-stroke: 1px #fff;
  text-stroke: 1px #fff;
  top: 0;
  left: 0;
}

.tanni.red {
  color: #fff;
  -webkit-text-stroke: 1px #ff1219;
  text-stroke: 1px #ff1219;
  top: 3px;
  left: 3px;
}

.bottom_text {
  position: relative;
  width: min-content;
  margin: 0 auto;
}

.mawaru_container {
  font-size: 3rem;
  position: relative;
  margin: 0 auto;
  width: 250px;
}

.mawaru.orange {
  position: absolute;
  top: 0;
  left: 0;
  color: #fbb03c;
  -webkit-text-stroke: 2px #ff1219;
  text-stroke: 2px #ff1219;
}

.mawaru.red {
  position: absolute;
  top: 3px;
  left: 3px;
  color: #ff1219;
  -webkit-text-stroke: 2px #fff;
  text-stroke: 2px #fff;
}

.exp_text {
  position: absolute;
  right: -8px;
  top: 14px;
  font-size: 2rem;
  transform: rotate(-14deg);
}

.exp_text .exp.white {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  -webkit-text-stroke: 1px #ff1219;
  text-stroke: 1px #ff1219;
}

.exp_text .exp.red {
  position: absolute;
  top: 3px;
  left: 3px;
  color: #ff1219;
  -webkit-text-stroke: 1px #fff;
  text-stroke: 1px #fff;
}

.footer_container {
  position: absolute;
  bottom: 0;
  height: 150px;
  width: 100%;
  text-align: center;
}

.footer_container img {
  height: 100px;
  width: auto;
}

.footer_container p {
  display: block;
  margin-top: 0.5rem;
  text-align: center;
  color: #fff;  
  cursor: pointer;
}
.footer_container a{
  text-decoration: none;
}
.footer_container a:hover {
  opacity: .6;
}
.br600 {
  display: none;
}
@media only screen and (max-width: 1280px) {
  .earth.init {
    width: 300px;
    height: 300px;
    top: 200px;
    left: 600px;
  }
}
@media only screen and (max-width: 1024px) {
  .title_container {
    max-width: 600px;
    position: relative;
  }

  .earth.init {
    top: 300px;
    left: 450px;
  }
}
@media only screen and (max-width: 768px) {
  .earth.time {
    width: 130vw;
    height: 130vw;
    left: -15vw;
    bottom: -65vw;
  }
  .earth.init {
    left: 400px;
  }
  .title_container {
    max-width: 475px;
  }
  .earth.init {
    width: 200px;
    height: 200px;
    top: 450px;
    left: 55%;
  }
  .earth.calc {
    width: 150px;
    height: 150px;
    top: calc(50vh - 75px);
    left: calc(50vw - 75px);
  }

  .calc_messsage {
    padding-left: 52px;
    margin-top: .5rem;
  }
}
@media only screen and (max-width: 600px) {
  .br600 {
    display: block;
  }

  .content_container {
    width: min-content;
    text-align: left;
  }
  .input_time_container {
    width: 300px;
    margin: 0 auto;
  }
  .input_time_container span {
    margin-bottom: 1rem;
  }

  .title_container {
    max-width: fit-content;
    margin: 0 auto;
  }

  .earth.init {
    width: 95px;
    height: 95px;
    top: 280px;
    left: 51%;
  }
}

@media only screen and (max-width: 475px) {
  .wrapper {
    padding: 2rem 0 0;
  }
  .title_l, .title_r{
    width: 66px;
  }

  .title_l > img, .title_r> img{
    width: 40px; 
  }
  .content_container {
    margin: 0 auto;
    height: 100%;
  }
  .input_time_container span {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .input_time_container {
    width: 220px;
  }
  .input_time_container span.date,
  .input_time_container span.time {
    padding: 0.5rem 1.25rem 0.5rem 2.75rem;
    border-radius: 4px;
    margin-right: 0.5rem;
    font-weight: bold;
  }
  .input_time_container span.date:before {
    top: 11px;
    left: 20px;
    width: 12px;
    height: 12px;
  }

  .rotate_num_container {
    margin-top: 68px;
  }

  .input_time_container span.time:before {
    top: 11px;
    left: 20px;
    width: 12px;
    height: 12px;
  }
  .chikyuu_text {
    padding: 0.5rem 0.75rem;
    font-size: 22px;
    top: -47px;
    left: -2rem;
  }
  .top_num {
    font-size: 33px;
  }
  .tanni {
    font-size: 19px;
  }
  .bottom_num {
    font-size: 60px;
  }
  .kai_text .tanni {
    font-size: 23px;
  }

  .mawaru_container {
    font-size: 34px;
    width: 175px;
  }
  .exp_text {
    font-size: 22px;
    right: -6px;
    top: 11px;
  }

  .footer_container{
    height: 120px;
  }

  .footer_container img {
    width: 160px;
    height: auto;
  }

  .footer_container a {
    margin-top: 0;
    font-size: 10px;
  }

  .chou_text {
    bottom: 14px;
    left: 17px;
  }

  .oku_text {
    bottom: 14px;
    left: 136px;
  }
  .man_text {
    position: absolute;
    bottom: 14px;
  }
  .kai_text {
    bottom: 29px;
    right: -6px;
  }
}
</style>
